// extracted by mini-css-extract-plugin
export default {"side-bar-content":"SidebarContentContainer_side-bar-content__aeHpX"};